import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "tw-flex tw-items-center tw-justify-center tw-relative" }
const _hoisted_2 = ["onClick", "onMouseover"]
const _hoisted_3 = {
  key: 0,
  class: "tw-absolute tw-top-[-60px] tw-h-[50px] tw-flex tw-items-end tw-justify-center tw-min-w-[130px]"
}
const _hoisted_4 = {
  key: 1,
  class: "tw-h-[32px] tw-w-[32px] tw-justify-center tw-flex tw-items-center"
}
const _hoisted_5 = { key: 2 }
const _hoisted_6 = {
  key: 0,
  class: "tw-h-[26px] tw-w-[26px] tw-justify-center tw-flex tw-items-center tw-ml-[3px] tw-mr-[3px]"
}
const _hoisted_7 = {
  key: 1,
  class: "tw-h-[28px] tw-w-[28px] tw-justify-center tw-flex tw-items-center"
}
const _hoisted_8 = {
  key: 3,
  class: "tw-h-[13.65px] tw-w-[13.65px] tw-m-[9.18px] tw-bg-[#DBDBDB] tw-rounded-full"
}
const _hoisted_9 = {
  key: 4,
  class: "tw-h-[13.65px] tw-w-[13.65px] tw-m-[9.18px] tw-bg-[#FFFFFF] tw-rounded-full"
}

import { PropType, ref, watch } from "vue";
import SuccessAnimation from "../../assets/animation/success.json";
import ErrorAnimation from "../../assets/animation/error.json";
import ProgressAnimation from "../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import { statusPage } from "@/utils/constants";

export default /*#__PURE__*/_defineComponent({
  __name: 'wizardProgressIndictor',
  props: {
  data: {
    type: Array as PropType<
      {
        title: string;
        id: number;
        statusPage: string;
        dataError: [];
      }[]
    >,
    required: true,
  },
  activeComponentId: {
    type: Number,
    required: true,
  },
},
  emits: ["on:navigateItem"],
  setup(__props, { emit }) {

const props = __props;



const idHover = ref(-1);
const activeComponent = ref(props.activeComponentId);



watch(
  () => props.activeComponentId,
  (value) => {
    activeComponent.value = value;
  },
  { deep: true },
);

const onClickItem = (id: number) => {
  emit("on:navigateItem", id);
  idHover.value = -1;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.data, (item) => {
      return (_openBlock(), _createElementBlock("button", {
        key: item?.id,
        class: "tw-items-center tw-justify-center tw-pt-0 tw-flex tw-bg-transparent tw-relative",
        onClick: ($event: any) => (onClickItem(item?.id)),
        onMouseover: ($event: any) => (idHover.value = item?.id),
        onMouseleave: _cache[0] || (_cache[0] = ($event: any) => (idHover.value = -1))
      }, [
        (idHover.value === item.id)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("p", {
                class: _normalizeClass([[
            activeComponent.value > item.id ? 'tw-bg-[#D9EDE2]' : 'tw-bg-white',
          ], "tw-text-[#01893D] tw-text-[11px] tw-font-medium tw-leading-[130%] tw-mb-[0px] tw-px-[5px] tw-py-[3px] tw-rounded-[4px] tw-text-center"])
              }, _toDisplayString(item?.title), 3)
            ]))
          : _createCommentVNode("", true),
        (item.statusPage === _unref(statusPage).CallApi)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(_unref(LottieAnimation), {
                ref_for: true,
                ref: "anim",
                "animation-data": _unref(ProgressAnimation),
                "auto-play": true,
                loop: true
              }, null, 8, ["animation-data"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (item.statusPage === _unref(statusPage).Error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createVNode(_unref(LottieAnimation), {
                      ref_for: true,
                      ref: "anim",
                      "animation-data": _unref(ErrorAnimation),
                      "auto-play": true,
                      loop: false
                    }, null, 8, ["animation-data"])
                  ]))
                : (item.statusPage === _unref(statusPage).Success)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_unref(LottieAnimation), {
                        ref_for: true,
                        ref: "anim",
                        "animation-data": _unref(SuccessAnimation),
                        "auto-play": true,
                        loop: false
                      }, null, 8, ["animation-data"])
                    ]))
                  : _createCommentVNode("", true)
            ])),
        (item.statusPage === _unref(statusPage).Updating)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8))
          : _createCommentVNode("", true),
        (item.statusPage === _unref(statusPage).NotChange)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9))
          : _createCommentVNode("", true)
      ], 40, _hoisted_2))
    }), 128))
  ]))
}
}

})